import onboarding from './onboarding'
import jobPoster from './jobPoster'
import jobPosting from './jobPosting'
import satisfactionSurvey from './satisfactionSurvey'
import postApplicant from './postApplicant'
import jobApplication from './jobApplication'
import jobTemplateManagement from './jobTemplateManagement'
import auditLogManagement from './auditLogManagement'
import applicantLock from './applicantLock'
import applicantStatusAutoChange from './applicantStatusAutoChange'
import userManagement from './userManagement'
import roleManagement from './roleManagement'
import hmManagement from './hmManagement'
import companyManagement from './companyManagement'
import employeeManagement from './employeeManagement'
import alumniManagement from './alumniManagement'
import agreement from './agreement'
import notification from './notification'
import applicantStatusNotificationTemplate from './applicantStatusNotificationTemplate'
import jobBoardPointDashboard from './jobBoardPointDashboard'
import weChatTemplate from './weChatTemplate'
import customLandingPage from './customLandingPage'
import agency from './agency'
import customJobDetailPageEdit from './customJobDetailPage'
import companyApprovalManagement from './companyApprovalManagement'
import jobLocationManagement from './jobLocationManagement'
import interviewQuestionTemplateManagement from './interviewQuestionTemplateManagement'
import candidateStatusManagement from './candidateStatusManagement'
import customJobFilter from './customJobFilter'
import sourceChannelManagement from './sourceChannelManagement'
import offerLetterInviteRecordManagement from './offerLetterInviteRecordManagement'
import siteMessageManagement from './siteMessageManagement'
import serviceAccountManagement from './serviceAccountManagement'
import adsTierManagement from './adsTierManagement'
import uploadDataManagement from './uploadDataManagement'
import customCompanyTheme from './customCompanyTheme'
import jobPostingManagement from './jobPostingManagement'
import exportData from './exportData'
import cashPointsManagement from './cashPointsManagement'
import cashOutManagement from './cashOutManagement'
import schoolManagement from './schoolManagement'
import majorManagement from './majorManagement'
import jobPostingChannelAccount from './jobPostingChannelAccount'
import thirdIntegrationConfigManagement from './thirdIntegrationConfigManagement'
import interviewMeetingRoomManagement from './interviewMeetingRoomManagement'
import aiChatbotConfigManagement from './aiChatbotConfigManagement'
import aiAgentManagement from './aiAgentManagement'
import questionnaireManagement from './questionnaireManagement'
import scoreScaleSetting from './scoreScaleSetting'

export default {
  title: 'Company Admin',
  tab: 'COMPANY ADMIN',
  userManagement,
  roleManagement,
  auditLogManagement,
  hmManagement,
  companyManagement,
  jobLocationManagement,
  jobTemplateManagement,
  notification,
  applicantStatusNotificationTemplate,
  applicantLock,
  applicantStatusAutoChange,
  alumniManagement,
  agreement,
  interviewQuestionTemplateManagement,
  emailManagement: {
    title: 'Customize Email Template',
    menu: 'Email Template Management'
  },
  customMobileLandingPage: {
    title: 'Landing Page Management',
    menu: 'Landing Page Management'
  },
  customJobDetailPage: {
    title: 'JD Page Management',
    menu: 'JD Page Management'
  },
  exportData,
  elcExportData: {
    title: 'Export Apply Data',
    menu: 'Export Apply Data'
  },
  dashboard: {
    title: 'Dashboard',
    menu: 'Dashboard'
  },
  companyData: {
    title: 'Company Data',
    menu: 'Company Data'
  },
  companyUserData: {
    title: 'Company User Data',
    menu: 'Company User Data'
  },
  candidateStatusManagement,
  vendorManagement: {
    title: 'Agency Management',
    menu: 'Agency Management'
  },
  customJobFilter,
  weChatTemplateMessageManagement: {
    title: 'WeChat Message Management Template',
    menu: 'WeChat Message Management Template'
  },
  microSiteManagement: {
    title: 'Microsite Management',
    menu: 'Microsite Management'
  },
  employeeManagement,
  onboarding,
  jobPoster,
  jobPosting,
  satisfactionSurvey,
  postApplicant,
  jobApplication,
  cashPointsManagement,
  cashOutManagement,
  sourceChannelManagement,
  jobBoardPointDashboard,
  group: {
    recruitManagement: 'Recruiting Management',
    companyInternalManagement: 'Account Management',
    customerBrandManagement: 'Career/Brand Management',
    dataManagement: 'Data Management',
    referralManagement: 'Referral Management'
  },
  weChatTemplate,
  customLandingPage,
  agency,
  customJobDetailPageEdit,
  companyApprovalManagement,
  offerLetterInviteRecordManagement,
  siteMessageManagement,
  serviceAccountManagement,
  adsTierManagement,
  uploadDataManagement,
  customCompanyTheme,
  jobPostingManagement,
  schoolManagement,
  majorManagement,
  jobPostingChannelAccount,
  thirdIntegrationConfigManagement,
  interviewMeetingRoomManagement,
  aiChatbotConfigManagement,
  aiAgentManagement,
  questionnaireManagement,
  scoreScaleSetting
}
